import { gql } from '@apollo/client';

export const GET_MILESTONES = gql`
  query GetMilestones {
    milestones {
      id
      key
    }
  }
`;

export const GET_MILESTONE_ATTACHMENTS = gql`
  query GetMilestoneAttachments {
    block {
      creator {
        name
      }
      blockImages {
        id
        imageUrl
        postedDate
      }
    }
  }
`;
export const RECLAIM_MILESTONE = gql`
  mutation reclaimMilestone($input: ReclaimMilestoneInput!) {
    reclaimMilestone(input: $input) {
      error
      milestone {
        id
        name
        hours
        currentStatus {
          id
          codeI18n
          activity
          rejectionType {
            id
          }
          rejectionSubReasonTypes {
            id
          }
          comments
          createdAt
          createdBy {
            id
            firstName
            lastName
          }
        }
      }
      commodity {
        weld {
          id
          earnedHours
          earnedQuantity
        }
        materialCommodity {
          id
          earnedHours
          earnedQuantity
          workPackage {
            id
            earnedHours
            earnedQuantity
          }
        }
      }
      workPackage {
        id
        percentageComplete
      }
    }
  }
`;

export const CLAIM_MILESTONE = gql`
  mutation claimMilestone($input: ClaimMilestoneInput!) {
    claimMilestone(input: $input) {
      error
      milestone {
        id
        name
        currentStatus {
          id
          codeI18n
          activity
          rejectionType {
            id
          }
          rejectionSubReasonTypes {
            id
          }
          comments
          createdAt
          createdBy {
            id
            firstName
            lastName
          }
        }
      }
      commodity {
        weld {
          id
          status {
            id
            status
          }
        }
      }
      workPackage {
        id
        percentageComplete
      }
    }
  }
`;

export const UNCLAIM_MILESTONE = gql`
  mutation unclaimMilestone($input: MilestoneStatusInput!) {
    unclaimMilestone(input: $input) {
      error
      milestone {
        id
        name
        currentStatus {
          id
          codeI18n
          rejectionType {
            id
            reason
          }
          comments
          createdAt
          createdBy {
            id
            firstName
            lastName
          }
        }
      }
      commodity {
        weld {
          id
          earnedHours
          earnedQuantity
          status {
            id
            status
          }
        }
        materialCommodity {
          id
          earnedHours
          earnedQuantity
          workPackage {
            id
            earnedHours
            earnedQuantity
          }
        }
      }
    }
  }
`;

export const REJECT_MILESTONE = gql`
  mutation rejectMilestone($input: RejectMilestoneInput!) {
    rejectMilestone(input: $input) {
      error
      milestone {
        id
        name
        timesRejected
        attachments {
          id
          url
          createdAt
          creator {
            id
            firstName
            lastName
            persona
            imageUrl
          }
        }
        currentStatus {
          id
          codeI18n
          rejectionType {
            id
            reason
          }
          comments
          createdAt
          createdBy {
            id
            firstName
            lastName
          }
        }
      }
      commodity {
        weld {
          id
          earnedHours
          earnedQuantity
        }
        materialCommodity {
          id
          earnedHours
          earnedQuantity
          workPackage {
            id
            earnedHours
            earnedQuantity
          }
        }
      }
    }
  }
`;

export const APPROVE_MILESTONE = gql`
  mutation approveMilestone($input: MilestoneStatusInput!) {
    approveMilestone(input: $input) {
      error
      milestone {
        id
        name
        currentStatus {
          id
          codeI18n
          rejectionType {
            id
            reason
          }
          comments
          createdAt
          createdBy {
            id
            firstName
            lastName
          }
        }
      }
      commodity {
        weld {
          id
          earnedHours
          earnedQuantity
        }
        materialCommodity {
          id
          earnedHours
          earnedQuantity
          workPackage {
            id
            earnedHours
            earnedQuantity
          }
        }
      }
      workPackage {
        id
        percentageComplete
      }
    }
  }
`;

export const UNAPPROVE_MILESTONE = gql`
  mutation unapproveMilestone($input: MilestoneStatusInput!) {
    unapproveMilestone(input: $input) {
      error
      milestone {
        id
        name
        currentStatus {
          id
          codeI18n
          rejectionType {
            id
            reason
          }
          comments
          createdAt
          createdBy {
            id
            firstName
            lastName
          }
        }
      }
      commodity {
        weld {
          id
          earnedHours
          earnedQuantity
        }
        materialCommodity {
          id
          earnedHours
          earnedQuantity
          workPackage {
            id
            earnedHours
            earnedQuantity
          }
        }
      }
      workPackage {
        id
        percentageComplete
      }
    }
  }
`;

export const DELETE_BLOCK_MEDIA = gql`
  mutation deleteBlockAttachment($input: DeleteBlockAttachmentInput!) {
    deleteBlockAttachment(input: $input) {
      error
      removed
    }
  }
`;

export const CLAIM_ALL_MILESTONES = gql`
  mutation claimAllMilestones($input: ClaimAllMilestonesInput!) {
    claimAllMilestones(input: $input) {
      erroredMilestones {
        errorCode
        milestone {
          id
          name
          currentStatus {
            id
            codeI18n
            rejectionType {
              id
              reason
            }
            comments
            createdAt
            createdBy {
              id
              firstName
              lastName
            }
          }
        }
      }
      milestones {
        id
        name
        type {
          id
        }
        currentStatus {
          id
          codeI18n
          rejectionType {
            id
            reason
          }
          comments
          createdAt
          createdBy {
            id
            firstName
            lastName
          }
        }
        commodity {
          weld {
            id
            earnedHours
            earnedQuantity
            workPackage {
              id
              earnedHours
              earnedQuantity
            }
          }
          materialCommodity {
            id
            earnedHours
            earnedQuantity
            workPackage {
              id
              earnedHours
              earnedQuantity
            }
          }
        }
      }
    }
  }
`;

export const APPROVE_ALL_MILESTONES = gql`
  mutation approveAllMilestones($input: ApproveAllMilestonesInput!) {
    approveAllMilestones(input: $input) {
      erroredMilestones {
        errorCode
        milestone {
          id
          name
          currentStatus {
            id
            codeI18n
            rejectionType {
              id
              reason
            }
            comments
            createdAt
            createdBy {
              id
              firstName
              lastName
            }
          }
        }
      }
      milestones {
        id
        name
        type {
          id
        }
        currentStatus {
          id
          codeI18n
          rejectionType {
            id
            reason
          }
          comments
          createdAt
          createdBy {
            id
            firstName
            lastName
          }
        }
        commodity {
          weld {
            id
            earnedHours
            earnedQuantity
            workPackage {
              id
              earnedHours
              earnedQuantity
            }
          }
          materialCommodity {
            id
            earnedHours
            earnedQuantity
            workPackage {
              id
              earnedHours
              earnedQuantity
            }
          }
        }
      }
    }
  }
`;

export const ADD_MILESTONE_ATTACHMENT = gql`
  mutation addMilestoneAttachment($input: AddMilestoneAttachmentInput!) {
    addMilestoneAttachment(input: $input) {
      milestone {
        id
        attachments {
          id
          url
          createdAt
          creator {
            id
            firstName
            lastName
            persona
            imageUrl
          }
        }
      }
      error
    }
  }
`;

export const GET_PROJECT_MILESTONE_TYPE_REASONS = gql`
  query projectMilestoneTypeRejectionReasons($input: ProjectMilestoneTypeRejectionReasonsInput!) {
    projectMilestoneTypeRejectionReasons(input: $input) {
      id
      reason
      subReasons {
        id
        reason
        comments
      }
    }
  }
`;

export const DELETE_MILESTONE_ATTACHMENT = gql`
  mutation deleteMilestoneAttachment($input: DeleteMilestoneAttachmentInput!) {
    deleteMilestoneAttachment(input: $input) {
      error
      milestone {
        id
        attachments {
          id
          url
          createdAt
          creator {
            id
            firstName
            lastName
            persona
            imageUrl
          }
        }
      }
    }
  }
`;
